<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form class="form" ref="query" :model="query" :rules="rules" label-position="left" label-width="145px" label-colon >
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="Weeks" :span="16" prop="month">
<!--              <el-date-picker-->
<!--                type="months"-->
<!--                v-model="query.month"-->
<!--                placeholder="Please Input"-->
<!--                style="width: 100%"-->
<!--                value-format="yyyy-MM"-->
<!--                clearable-->
<!--              >-->
<!--              </el-date-picker>-->
              <el-date-picker
                v-model="weekRange"
                type="daterange"
                start-placeholder="Start week"
                end-placeholder="End week"
                format="yyyy-MM-dd"
                style="width: 100%"
                @change="handleDateChange"
                :picker-options="pickerOptions">
              </el-date-picker>
              <div v-if="selectedWeeks.length > 0">
                <h3>Selected Weeks:</h3>
                <ul>
                  <li v-for="(week, index) in selectedWeeks" :key="index">
                    Week {{ index + 1 }}: {{ week.start }} to {{ week.end }}
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item
              label="User"
            >
              <el-select
                v-model="query.user"
                filterable
                clearable
                multiple
                style="width: 100%"
                :loading="loading1"
              >
                <el-option
                  v-for="(item) in userList"
                  :value="item.value"
                  :key="item.label"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Class">
              <el-cascader
                v-model= "cateVal"
                :options = "cateList"
                :props="{ checkStrictly: true }"
                placeholder="Please Input"
                clearable
                filterable
                @change="handleChange"
                style="width:260px"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="margin-top: 5px; text-align: left">
          <el-button type="primary" @click="getExSummaryList">
            Search
          </el-button>
          <el-button type="primary" @click="getExSummaryExcel">
            Export
          </el-button>
        </div>

        <!--        <el-row :gutter="16">-->
        <!--          <el-col :span="6">-->
        <!--            <el-button type="primary" :span="3" @click="getReportSummaryList">-->
        <!--              Search-->
        <!--            </el-button>-->
        <!--          </el-col>-->
        <!--          <el-col :span="10">-->
        <!--            <el-button type="primary" :span="6" @click="getReportSummaryExcel">-->
        <!--              Export-->
        <!--            </el-button>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always" title="Weekly Report" label-width="145px" label-colon>
      <el-form>
        <el-row :gutter="16">
          <el-table
            :data="reportSummaryList"
            border
            style="width: 100%">
            <el-table-column
              prop="fullName"
              label="User"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="weekStart"
              label="Week Start"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="weekEnd"
              label="Week End"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="category"
              label="Class-Lv1"
              width="140"
            >
            </el-table-column>

            <el-table-column
              prop="category2nd"
              label="Class-Lv2"
              width="160"
            >
            </el-table-column>

            <el-table-column
              prop="category3rd"
              label="Class-Lv3"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="subClass"
              label="Sub Class"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="time"
              label="Hours"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="percentage"
              label="Progress"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="description"
              label="Description"
              width="300"
            >
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
    </el-card>

    <!--    <el-row :gutter="16">-->
    <!--      <el-card>-->
    <!--        <div-->
    <!--          id="report"-->
    <!--        >-->
    <!--        </div>-->
    <!--      </el-card>-->

    <!--    </el-row>-->
  </div>
</template>

<script>
import reportApi from '@/api/report.js';
import userApi from "@/api/user";
import moment from 'moment';

export default {
  name: "exSummary",
  data() {
    return {
      weekRange: [],
      selectedWeeks: [],
      pickerOptions: {
        // disabledDate(time) {
        //   // 限制不能选择未来的日期（可选）
        //   return time.getTime() > Date.now();
        // },
        onPick({maxDate, minDate}) {
          // 限制只能选择同一年的日期范围
          if (minDate && maxDate) {
            const startYear = new Date(minDate).getFullYear();
            const endYear = new Date(maxDate).getFullYear();
            // 如果开始和结束日期不在同一年，重置结束日期为当年最后一天
            if (startYear !== endYear) {
              this.$emit('pick', [
                minDate, // 起始日期保持不变
                new Date(startYear, 11, 31) // 将结束日期调整为该年的最后一天（12月31日）
                  ]);
                }
              }
        }
      },
      loading: false,
      cateVal: [],
      cateList: [],
      reportSummaryList: [],
      userList:[],
      bar: [],
      editIndex: -1,
      isEdit: -99,
      loading1: false,
      query: {
        months: [],
        week:"",
        user:'',
        category:'',
        category2nd:'',
        currentPage:'',
        totalPage:'',
        pageSize:'',
      },
      rules:{
        week: [{
          required:true, message:'Please Input', trigger:'blur'
        }]
      }
      // rules:{
      //   month: [{
      //     required:true, message:'Please Input', trigger:'blur'
      //   }],
      // },
    }
  },

  methods: {
    handleDateChange([start, end]) {
      if (start && end) {
        // 将日期范围修正为整周
        const startOfWeek = this.getStartOfWeek(start);
        const endOfWeek = this.getEndOfWeek(end);
        // 检查是否跨年周
        const startYear = new Date(startOfWeek).getFullYear();
        const endYear = new Date(endOfWeek).getFullYear();
        if (startYear !== endYear) {
          // 如果该周的结束日期跨年，则取消选择并提示用户
          this.weekRange = [];
          this.selectedWeeks = [];
          this.$message({
            message: '跨年周不可选择，请重新选择日期范围。',
            type: 'warning',
          });
          return;
        }
        // 如果没有跨年，更新选择的周范围
        this.weekRange = [startOfWeek, endOfWeek];
        this.calculateSelectedWeeks(startOfWeek, endOfWeek);
      }
    },
    getStartOfWeek(date) {
      // 使用 moment.js 获取该日期的周一
      return moment(date).startOf('week').toDate();
    },
    getEndOfWeek(date) {
      // 使用 moment.js 获取该日期的周日
      return moment(date).endOf('week').toDate();
    },
    calculateSelectedWeeks(start, end) {
      this.selectedWeeks = [];
      let currentStart = moment(start);

      // 逐周计算并推入 selectedWeeks 数组
      while (currentStart.isBefore(end) || currentStart.isSame(end)) {
        const currentEnd = currentStart.clone().endOf('week');
        this.selectedWeeks.push({
          start: currentStart.format('YYYY-MM-DD'),
          end: currentEnd.format('YYYY-MM-DD')
        });
        currentStart.add(1, 'week');
      }
    },

    showDate() {
      let startTime = this.dayjs(this.query.week).subtract(1, "day").$d;
      let endTime = this.dayjs(startTime).add(6, "day").$d;
      this.query.start = this.dayjs(startTime).format("YYYY-MM-DD");
      this.query.end = this.dayjs(endTime).format("YYYY-MM-DD");
    },
    newDateWeekHandle() {
      const now = new Date(this.query.week);
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;

      //const mondayTime = nowTime - (day-1)*oneDayTime;
      const sundayTime = nowTime + (day-2)*oneDayTime;
      const saturdayTime = nowTime + (7-day-1)*oneDayTime;
      this.query.start = this.$moment(sundayTime).format('YYYY-MM-DD');
      this.query.end = this.$moment(saturdayTime).format('YYYY-MM-DD');
    },
    getCategoryList() {
      reportApi.getCategory().then(
        res => {
          this.cateList = res.data.data
        }
      )
    },
    getExSummaryList() {
      this.$refs.query.validate((valid) => {
        if (valid) {
          let data = {}
          if (this.selectedWeeks) {
            data['weeks'] = this.selectedWeeks
          }
          if (this.query.user) {
            data['user_ids'] = this.query.user
          }
          if (this.cateVal) {
            data['category'] = this.cateVal[0]
            data['category2nd'] = this.cateVal[1] ? this.cateVal[1] : null
          }
          data['offset'] = this.query.pageSize * (this.query.currentPage -1)
          data['limit'] = this.query.pageSize
          reportApi.getExSummary(data).then(
            res => {
              this.reportSummaryList = res.data.data
              this.query.totalPage = res.data.total
            }
          )
        } else {
          this.$message.error("Please filled with Month")
        }
      })
    },

    async getExSummaryExcel() {
      this.$refs.query.validate((valid) => {
        if (valid) {
          let data = {}
          if (this.selectedWeeks) {
            data['weeks'] = this.selectedWeeks
          }
          if (this.query.user) {
            data['user_ids'] = this.query.user
          }
          if (this.cateVal) {
            data['category'] = this.cateVal[0]
            data['category2nd'] = this.cateVal[1] ? this.cateVal[1] : null
          }
          reportApi.getExSummaryExcel(data).then(
            resp => {
              const blob = new Blob([resp])
              console.log(blob)
              const url = URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = 'data.xls'
              link.click()
              // 释放URL对象
              URL.revokeObjectURL(url)
            }
          )
        } else {
          this.$message.error("Please filled with Month")
        }
      })
    },


    handleChange() {
      console.log(this.cateVal);
    },
    // dataFilter(node: { text: string; }, val: string) {
    //   if (!!~node.text.indexOf(val) || !!~node.text.toUpperCase().indexOf(val.toUpperCase())) {
    //     return true
    //   }
    // },
    getSelects() {
      let para = {}
      para["country"] = "China"
      userApi.getUsers(para).then(res=> {
        let users = res.data
        for (let user of users) {
          this.userList.push({value: user.id, label: user['fullName']})
        }
      })
    },

  },
  mounted() {
    this.getSelects()
    this.getCategoryList()
  }
}
</script>

<style lang="scss" scoped>
.st-table {
  padding:10px
}

</style>

